import _ from 'lodash';
import {
    FETCH_RAINPRO_LABELS,
    CLEAN_RAINPRO_LABELS,
    DOWNLOAD_RAINPRO_LABEL,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproLabels = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/labels', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_LABELS, payload: data });
    });
};

export const downloadRainproLabel = id => ({ type: DOWNLOAD_RAINPRO_LABEL, payload: id });

export const cleanRainproLabels = () => ({ type: CLEAN_RAINPRO_LABELS });
